<template>
  <funnel-step-layout anchor="entity">
    <div>{{$t('step1.title')}}</div>
    <div class="container">
      <div class="row">
        <div class="col-12 mt-5">
          <bubbles>
            <bubble-item v-for="entity in entities"
            @touch="onTouchEntity"
            @click="onSelectEntity"
            :key="entity"
            :id="entity"
            :value="entity"
            :label="$t(`step1.${entity}.label`)"
            :icon="$t(`step1.${entity}.icon`)"
            :description="$t(`step1.${entity}.description`)"
            :selected="inputs.entity === entity"
             />
          </bubbles>
        </div>
      </div>
    </div>
    <px-button class="d-block d-md-none" :disabled="!canGoNext" @click="goNextStep" :text="$t('common.next_cta')"></px-button>
  </funnel-step-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import {FunnelStepLayout} from '@/components/Layouts'
import { Bubbles, BubbleItem } from '@/components/UIComponents'

export default {
  name: 'step-entity-type-option',
  components: {
    FunnelStepLayout,
    Bubbles,
    BubbleItem
  },
  data () {
    return {
      previousTouched: null
    }
  },
  methods: {
    goNextStep () {
      this.$onePage.moveNext()
    },
    onTouchEntity (item) {
      if (this.previousTouched) {
        if (item.id !== this.previousTouched.id) {
          this.previousTouched.removeTouch()
        }
      }
      this.previousTouched = item
      this.$store.dispatch('form/option_entity', item.value)
    },
    onSelectEntity (item) {
      this.$onePage.moveNext()
      this.$store.dispatch('form/option_entity', item.value)
    }
  },
  computed: {
    ...mapGetters({
      entities: 'entities',
      inputs: 'form/inputs',
      canGoNext: 'form/can_display_goals'
    })
  }
}
</script>
